/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Conflict_Changed_AtInputs */

const en_conflict_changed_at = /** @type {(inputs: Conflict_Changed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changed at ${i?.time}.`)
};

/**
* | output |
* | --- |
* | "Changed at {time}." |
*
* @param {Conflict_Changed_AtInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const conflict_changed_at = /** @type {((inputs: Conflict_Changed_AtInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conflict_Changed_AtInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_conflict_changed_at(inputs)
});